import { cn } from '@/shared/utils';

const TopScoreCard = ({ data }) => {
  const { position, playerName, score } = data;
  return (
    <section className="flex items-center gap-2.5 p-2 rounded-lg w-full max-md:flex-wrap bg-[#2F3E3E]">
      <h2 className="text-lg font-semibold tracking-tight leading-5 text-white w-10 text-center">
        {position}
      </h2>
      <div className="flex flex-col flex-1 gap-1">
        <h3 className="text-lg font-semibold tracking-tight leading-5 text-white">
          {playerName}
        </h3>
        {/* <p className="text-base tracking-tight leading-5 text-secondary">
          Lane {lane}
        </p> */}
      </div>
      <div
        className={cn(
          'justify-center self-stretch items-center px-2 py-1',
          'text-xl font-semibold tracking-wider leading-6 flex text-yellow-300',
          'rounded bg-neutral-800'
        )}
        tabIndex="0"
      >
        {score}
      </div>
    </section>
  );
};

export default TopScoreCard;
